import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';

const API_BASE_URL = 'https://myreadyroom-api-crchhghhctcvgagq.westus2-01.azurewebsites.net';

export default function Callback() {
  const navigate = useNavigate();
  const { user, isAuthenticated, isLoading } = useAuth0();

  useEffect(() => {
    if (isLoading) return;
    if (isAuthenticated && user) {
      // Register or login the social user in our backend
      axios.post(`${API_BASE_URL}/api/auth/social`, {
        email: user.email,
        fullName: user.name,
        provider: user.sub?.split('|')[0],
        providerId: user.sub
      }).then(response => {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        navigate('/home');
      }).catch(() => {
        navigate('/');
      });
    }
  }, [isAuthenticated, isLoading, user, navigate]);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#0A0F1E', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center' }}>
        <p style={{ color: '#3B82F6', fontSize: '11px', letterSpacing: '6px', fontWeight: '700' }}>VIRILITER</p>
        <p style={{ color: '#475569', fontSize: '16px', marginTop: '16px' }}>Signing you in...</p>
      </div>
    </div>
  );
}